import { useState } from 'react';
import { FiPlus } from 'react-icons/fi';
import AdminTables from '@components/admin/AdminTables';
import AdminForms from '@components/admin/AdminForms';
import Modal from '@components/common/Modal';
import Button from '@components/common/Button';

const AdminB2BAccounts = () => {
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [selectedAccount, setSelectedAccount] = useState(null);

  // Mock data - replace with real API
  const accounts = [
    {
      id: 1,
      companyName: 'Security Solutions Ltd',
      contactName: 'John Doe',
      email: 'john@securitysolutions.com',
      phone: '+44 20 1234 5678',
      status: 'active',
      discount: 15,
    },
    {
      id: 2,
      companyName: 'Tech Installations Inc',
      contactName: 'Jane Smith',
      email: 'jane@techinstall.com',
      phone: '+44 20 8765 4321',
      status: 'active',
      discount: 20,
    },
  ];

  const columns = [
    { key: 'id', label: 'ID' },
    { key: 'companyName', label: 'Company Name' },
    { key: 'contactName', label: 'Contact' },
    { key: 'email', label: 'Email' },
    { key: 'phone', label: 'Phone' },
    { 
      key: 'discount', 
      label: 'Discount',
      render: (value) => `${value}%`
    },
    {
      key: 'status',
      label: 'Status',
      render: (value) => (
        <span className={`px-2 py-1 rounded-full text-xs font-semibold ${
          value === 'active' ? 'bg-green-100 text-green-600' :
          value === 'pending' ? 'bg-yellow-100 text-yellow-600' :
          'bg-red-100 text-red-600'
        }`}>
          {value.charAt(0).toUpperCase() + value.slice(1)}
        </span>
      )
    },
  ];

  const formFields = [
    { name: 'companyName', label: 'Company Name', type: 'text', required: true },
    { name: 'contactName', label: 'Contact Name', type: 'text', required: true },
    { name: 'email', label: 'Email', type: 'email', required: true },
    { name: 'phone', label: 'Phone', type: 'tel', required: true },
    { name: 'registrationNumber', label: 'Company Registration', type: 'text', required: true },
    { name: 'vatNumber', label: 'VAT Number', type: 'text', required: true },
    { name: 'address', label: 'Business Address', type: 'textarea', required: true },
    { 
      name: 'discount', 
      label: 'Discount (%)', 
      type: 'number',
      validation: { min: 0, max: 50 }
    },
    {
      name: 'status',
      label: 'Status',
      type: 'select',
      options: [
        { value: 'pending', label: 'Pending' },
        { value: 'active', label: 'Active' },
        { value: 'inactive', label: 'Inactive' },
      ]
    },
  ];

  const handleAdd = (data) => {
    console.log('Add B2B account:', data);
    setIsAddModalOpen(false);
  };

  const handleEdit = (account) => {
    setSelectedAccount(account);
    setIsEditModalOpen(true);
  };

  const handleUpdate = (data) => {
    console.log('Update B2B account:', selectedAccount.id, data);
    setIsEditModalOpen(false);
    setSelectedAccount(null);
  };

  const handleDelete = (account) => {
    if (window.confirm(`Are you sure you want to delete ${account.companyName}?`)) {
      console.log('Delete B2B account:', account.id);
    }
  };

  return (
    <div>
      <div className="flex items-center justify-between mb-8">
        <div>
          <h1 className="text-3xl font-bold text-gray-900">B2B Accounts</h1>
          <p className="text-gray-600 mt-2">Manage business customer accounts</p>
        </div>
        <Button
          text="Add Account"
          type="primary"
          onClick={() => setIsAddModalOpen(true)}
          icon={<FiPlus />}
        />
      </div>

      <AdminTables
        columns={columns}
        data={accounts}
        onEdit={handleEdit}
        onDelete={handleDelete}
      />

      {/* Add Account Modal */}
      <Modal
        isOpen={isAddModalOpen}
        onClose={() => setIsAddModalOpen(false)}
        title="Add B2B Account"
        size="lg"
      >
        <AdminForms
          fields={formFields}
          onSubmit={handleAdd}
          submitButtonText="Add Account"
        />
      </Modal>

      {/* Edit Account Modal */}
      <Modal
        isOpen={isEditModalOpen}
        onClose={() => {
          setIsEditModalOpen(false);
          setSelectedAccount(null);
        }}
        title="Edit B2B Account"
        size="lg"
      >
        {selectedAccount && (
          <AdminForms
            fields={formFields}
            initialData={selectedAccount}
            onSubmit={handleUpdate}
            submitButtonText="Update Account"
          />
        )}
      </Modal>
    </div>
  );
};

export default AdminB2BAccounts;

